import "./RaikoShowPrice.scss"
import {convertCurrencyFormatPositiveNegative} from "@moeindal/base-raiko-panel-components";

export default function RaikoShowPrice(
    {
        amount,
        centerTextAlign = true
    }
) {
    return (
        <div className={"baseRaikoShowPriceContainer"}>
            <span
                className={`
                    ${centerTextAlign ? "textAlignCenter" : "textAlignStart"} 
                    ${amount && parseInt(amount) >= 0 ? "positiveAmount" : "negativeAmount"}
                    `}>
                {
                    convertCurrencyFormatPositiveNegative(amount)
                }
            </span>
        </div>
    )
}
